import React from 'react';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import CheckoutForm2 from './CheckoutForm2';
import CheckoutSummary2 from './CheckoutSummary2';
import { useContext } from 'react';
import { GlobalContext } from '../context/GlobalState';
import { paymentTypes } from 'constants';

const paymentOptions = [
  {
    name: paymentTypes.cashOnDelivery,
    description:
      'Плащане при доставка, в брой или чрез банкова карта, при получаване на доставката.'
  },
  {
    name: paymentTypes.bankTransfer,
    description:
      'Направете плащането директно в банковата ни сметка. Използвайте уникалния идентификационен номер на поръчката като основание за плащане. Поръчката няма да бъде изпратена преди получаването на превод по нашата сметка. Прочетете повече в Начини на плащане.'
  }
];

export default function Checkout() {
  const { cartList, shippingOption } = useContext(GlobalContext);

  // Delivery still starts empty (the customer must pick one), but payment is
  // preselected to pay-on-delivery - the most common choice - so it's ready by default.
  const [paymentOptionSelected, setPaymentOptionSelected] = React.useState(paymentOptions[0].name);

  // Errors only appear once the customer has actually tried to place the order, not while typing.
  const [submitAttempted, setSubmitAttempted] = React.useState(false);

  const deliveryMissing = !shippingOption?.name;
  const paymentMissing = !paymentOptionSelected;
  const choicesMissing = deliveryMissing || paymentMissing;

  const subtotal =
    cartList.reduce(
      (accumulator, item) => accumulator + parseFloat(item.price) * item.quantity,
      0
    ) || 0;
  // Until a delivery option is chosen its price is the 0.00 sentinel, so the total is just the goods.
  const total = subtotal + parseFloat(shippingOption?.price_eur || 0);

  return (
    <Container style={{ backgroundColor: '', paddingTop: 30, justify: 'center' }}>
      <Grid container spacing={3}>
        <Grid item lg={5} md={5} xs={12}>
          <CheckoutSummary2
            paymentOptionSelected={paymentOptionSelected}
            paymentOptions={paymentOptions}
            setPaymentOptionSelected={setPaymentOptionSelected}
            subtotalOrderPrice={subtotal}
            totalOrderPrice={total}
            deliveryError={submitAttempted && deliveryMissing}
            paymentError={submitAttempted && paymentMissing}
          />
        </Grid>
        <Grid item lg={7} md={7} xs={12}>
          <CheckoutForm2
            paymentOptionSelected={paymentOptionSelected}
            subtotalOrderPrice={subtotal}
            totalOrderPrice={total}
            choicesMissing={choicesMissing}
            choicesError={submitAttempted && choicesMissing}
            onChoicesMissing={() => setSubmitAttempted(true)}
          />
        </Grid>
      </Grid>
    </Container>
  );
}
